c<template>
  <div>
    <div class="form-all">
      <div class="win">
        <slot name="title"></slot>
        <div class="form">
          <form @submit.prevent="submit" class="form-main" ref="form">
            <!-- 所在城市 -->
            <tgo-city @exportValue="getValue" :regCity="regCity" :info="info" ref="tgoCity"></tgo-city>
            <!-- 所在企业 -->
            <div v-for="(item, index) in [infoConfig['company']]" :key="`company-${index}`">
              <form-item v-if="info[item.key]" :item="item" :ref="item.key" @setOKList="setOKList" :haveBorder="false" :modify="false">
                <div slot="input">{{info[item.key]}}</div>
              </form-item>
              <!-- <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input
                slot="input"
                class="text-input"
                placeholder="请输入所在企业"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
              </form-item> -->
            </div>
            <!-- 职位 -->
            <div v-for="(item, index) in [infoConfig['job_title']]" :key="`jt-${index}`">
              <form-item :item="item" :haveBorder="false" :iview="true" :ref="item.key" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="jobTitles"
                :value="info[item.key]"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <template v-if="info['job_title'] === '12'">
              <div v-for="(item, index) in [infoConfig['job_title_content']]" class="job-title-content" :key="`jtc-${index}`">
                <span>{{item.subName}}</span>
                <form-item :item="item" :ref="item.key" @setOKList="setOKList" class="jtc-wrap">
                  <input
                  slot="input"
                  class="text-input"
                  placeholder="请输入职位名称"
                  type="text"
                  v-model="info[item.key]"
                  @focus="focusItem(item)"
                  @blur="blurItem(item)">
                </form-item>
              </div>
            </template>
            <!-- 行业领域 -->
            <template v-if="companyIndustrys">
              <div v-for="(item, index) in [infoConfig['company_industry']]" :key="`ci-${index}`">
                <!-- <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList" :modify="false">
                  <div slot="input">{{companyIndustrys}}</div>
                </form-item> -->
                <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                  <tgo-select
                  slot="input"
                  :tkey="item.key"
                  :multiple="true"
                  :selects="companyIndustrys"
                  :value="info[item.key]"
                  @input="getValue"
                  @blur="blurItem(item)">
                  </tgo-select>
                </form-item>
              </div>
            </template>
            <!-- 融资阶段 -->
            <template v-if="companyTypes[0].name">
              <div v-for="(item, index) in [infoConfig['company_type']]" :key="`ct-${index}`">
                <!-- <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList" :modify="false">
                  <div slot="input">{{companyTypes[0].name}}</div>
                </form-item> -->
                <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                  <tgo-select
                  slot="input"
                  :tkey="item.key"
                  :selects="companyTypes"
                  :value="info[item.key]"
                  @input="getValue"
                  @blur="blurItem(item)">
                  </tgo-select>
              </form-item>
              </div>
            </template>
            <!-- 企业规模人数 -->
            <template v-if="companyScales[0].name">
              <!-- <div v-for="(item, index) in [infoConfig['company_scale']]" class="scale" :key="`cs-${index}`">
                <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList" :modify="false">
                  <div slot="input">{{companyScales[0].name}}</div>
                </form-item>
              </div> -->
              <div class="company-scale">
                <div v-for="(item, index) in [infoConfig['company_scale']]" :key="`cs-${index}`" class="scale">
                  <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                    <tgo-select
                    slot="input"
                    :tkey="item.key"
                    :selects="companyScales"
                    :value="info[item.key]"
                    @input="getValue"
                    @blur="blurItem(item)">
                    </tgo-select>
                  </form-item>
                </div>
                <div v-for="(item, index) in [infoConfig['company_remark']]" :key="`cr-${index}`" class="remark">
                  <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                    <input
                    slot="input"
                    class="text-input"
                    placeholder="如：年收入5亿元，上轮融资13亿元"
                    type="text"
                    v-model="info[item.key]"
                    @focus="focusItem(item)"
                    @blur="blurItem(item)">
                  </form-item>
                </div>
              </div>
            </template>
            <!-- 企业规模备注 -->
            <!-- <div v-for="(item, index) in [infoConfig['company_remark']]" class="remark" :key="`cr-${index}`">
              <form-item  v-if="info[item.key]" :item="item" :ref="item.key" @setOKList="setOKList" :haveBorder="false" :modify="false">
                <div slot="input" style="word-break:break-word">{{info[item.key]}}</div>
              </form-item>
            </div> -->
            <!-- 企业研发团队规模人数 -->
            <div v-for="(item, index) in [infoConfig['company_develop']]"  :key="`cd-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <!-- <div slot="input">{{companyDevelops[0].name}}</div> -->
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="companyDevelops"
                :value="info[item.key]"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 本人现带领团队规模人数 -->
            <div v-for="(item, index) in [infoConfig['managed_team_size']]" :key="`mts-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="managedTeamSizes"
                :value="info[item.key]"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 本人曾带领团队最大规模（人数） -->
            <div v-for="(item, index) in [infoConfig['development_team_size']]" :key="`dts-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="managedTeamSizes"
                :value="info[item.key]"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 从事研发工作起始年 -->
            <div v-for="(item, index) in [infoConfig['developed_start_year']]" :key="`dsy-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <DatePicker
                slot="input"
                type="year"
                :tKey="item.key"
                placeholder="请选择"
                :value="info[item.key]"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></DatePicker>
              </form-item>
            </div>
            <!-- 从事管理工作起始年 -->
            <div v-for="(item, index) in [infoConfig['managed_start_year']]" :key="`msy-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <DatePicker
                slot="input"
                type="year"
                :tKey="item.key"
                placeholder="请选择"
                :value="info[item.key]"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></DatePicker>
              </form-item>
            </div>
            <!-- 工作经历 -->
            <div v-for="(item, index) in [infoConfig['work_experience']]" :key="`we-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="如：2009-2012年，担任惠普中国研究院（HP Labs China）资深研究员；"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}
                </div>
              </form-item>
            </div>
            <!-- 职业成就 -->
            <div v-for="(item, index) in [infoConfig['achievements']]" :key="`ach-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="如：2014年10月，作为合伙人加入北京泰迪熊移动科技有限公司，三年多的发展，已成为行业最强的通讯录解决方案供应商；"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}
                </div>
              </form-item>
            </div>
            <!-- 学习经历 -->
            <div v-for="(item, index) in [infoConfig['study_experience']]" :key="`se-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="如：2002-2006，清华大学计算机系，本科；"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}
                </div>
              </form-item>
            </div>
            <!-- 可提供资源 -->
            <div v-for="(item, index) in [infoConfig['support_resource']]" :key="`sr-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="您愿意为其他学员提供哪些资源？例如：技术管理话题分享，九折购买本公司云服务、融资创业专业渠道与建议等。"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 期望获得的价值 -->
            <div v-for="(item, index) in [infoConfig['want_resource']]" :key="`wr-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="您希望通过 TGO 获得什么？
例如：交流分享管理技术，学习软技能，拓展人脉等。请您尽量详细填写您的诉求"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 备注信息 -->
            <div class="remark-to-user">
               备注：如需修改企业信息，请联系客服。
            </div>
            <!-- <save-cancel @cancelConfirm="cancelConfirm" @submit="submit"></save-cancel> -->
            <div class="save-cancel-btns">
              <div class="cancel-btn" @click="cancelHandler">取消</div>
              <div class="save-btn" @click="saveHandler">保存</div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import infoConfig from './info-config'
import tgoSelect from '@/components/form/select'
import DatePicker from '@/components/form/date-picker'
import formItem from '@/components/form/form.item.com'
import lodash from 'lodash'
// import saveCancel from '@/components/account/save.cancel.vue'
import tgoCity from './linkSelect'
// import tgoCheckbox from '@/components/form/checkbox'

// static 数据
import { jobTitles, companyIndustrys, companyTypes, companyScales, companyDevelops, teamSizes as managedTeamSizes } from '@/data/form'

import * as GlobalLayer from '@/util/globalLayer'

export default {
  data () {
    return {
      infoConfig,
      warn: {},
      remainNumber: {},
      regCity: true,
      // 静态数据引入
      // staticDataMap: staticDataMap,
      jobTitles,
      managedTeamSizes,
      companyIndustrys,
      companyTypes,
      companyDevelops,
      companyScales
    }
  },
  components: {
    DatePicker,
    tgoSelect,
    formItem,
    // saveCancel,
    tgoCity
    // tgoCheckbox
  },
  props: ['info', 'detailInfo'],
  created () {
  },
  methods: {
    submit () {
      // console.log(lodash.isEqual(this.info, this.detailInfo))
      if (!lodash.isEqual(this.info, this.detailInfo)) {
        for (let key in this.infoConfig) {
          if (this.infoConfig[key].required) {
            this.blurItem(this.infoConfig[key])
          }
        }
        if (!Number.isNaN(parseInt(this.info['country'])) && !Number.isNaN(parseInt(this.info['province'])) && !Number.isNaN(parseInt(this.info['city']))) {
          this.regCity = true
        } else {
          this.regCity = false
          alert('您修改的表单内容部分有误，请修改！')
          return
        }
        for (let key in this.warn) {
          if (this.warn[key] === false) {
            return
          }
        }
        this.$emit('submit', this.info)
      } else {
        this.$emit('submit', this.info)
      }
    },
    blurItem (item) {
      this.$refs[item.key][0].blurFn(item, this.info)
    },
    focusItem (item) {
      this.$refs[item.key][0].focused = true
    },
    getValue (data) {
      // if (data.key === 'company_industry') {
      //   this.info[data.key] = [data.value]
      // } else {
      //   this.info[data.key] = data.value
      // }
      this.info[data.key] = data.value
    },
    /**
     * 存储已经符合规格的input的键值集合
     */
    setOKList (item) {
      if (item.warning.valid) {
        this.warn[item.key] = true
      } else {
        this.warn[item.key] = false
      }
    },
    // cancelConfirm () {
    //   this.showTip = false
    //   this.$emit('setState')
    // },
    /**
     * 限制字数
     * @param {String} v 用户输入字数
     * @param {String} key 键值
     * @param {Number} number 限定字数
     */
    limitNumber (v, key, number) {
      if (v.length > number) {
        this.info[key] = this.info[key].slice(0, number)
        this.remainNumber[key] = 0
      } else {
        this.remainNumber[key] = number - v.length
      }
    },
    cancelHandler () {
      GlobalLayer.createModal(this.$store, {
        title: '温馨提示',
        content: '<h2>取消后您的修改将会丢失</h2><h3>确认取消？</h3>',
        on: {
          confirm: (layer) => {
            this.$emit('setState')
            layer.close()
          }
        }
      })
    },
    saveHandler () {
      // 是否有修改企业信息
      let companyKeys = ['company_industry', 'company_type', 'company_scale', 'company_remark', 'company_develop']
      let enterPriseModify = companyKeys.find(key => JSON.stringify(this.info[key]) !== JSON.stringify(this.detailInfo[key]))

      if (enterPriseModify !== undefined) {
        GlobalLayer.createModal(this.$store, {
          title: '温馨提示',
          content: '<h2>修改的信息中包含企业信息</h2><h3>确认修改？</h3>',
          on: {
            confirm: (layer) => {
              this.submit()
              layer.close()
            }
          }
        })
      } else {
        this.submit()
      }
    }
  },
  // computed: {
  //   companyIndustrys () {
  //     if (Array.isArray(this.info.company_industry)) {
  //       let companyIndustrys = {}
  //       let string = ''
  //       this.staticDataMap.companyIndustrys.forEach(item => {
  //         companyIndustrys[item.id] = item
  //       })
  //       this.info.company_industry.map(id => companyIndustrys[id]).forEach(item => {
  //         string = string + item.name + '、'
  //       })
  //       return string.substring(0, string.length - 1)
  //     } else {
  //       return ''
  //     }
  //   },
  //   companyTypes () {
  //     if (this.info.company_type) {
  //       let arr = this.staticDataMap.companyTypes.filter(i => i.id === Number(this.info.company_type))
  //       if (arr.length) {
  //         return arr
  //       } else {
  //         return [{ name: '' }]
  //       }
  //     } else {
  //       return [{ name: '' }]
  //     }
  //   },
  //   companyScales () {
  //     if (this.info.company_scale) {
  //       let arr = this.staticDataMap.companyScales.filter(i => i.id === Number(this.info.company_scale))
  //       if (arr.length) {
  //         return arr
  //       } else {
  //         return [{ name: '' }]
  //       }
  //     } else {
  //       return [{ name: '' }]
  //     }
  //   },
  //   companyDevelops () {
  //     if (this.info.company_develop) {
  //       let arr = this.staticDataMap.companyDevelops.filter(i => i.id === Number(this.info.company_develop))
  //       if (arr.length) {
  //         return arr
  //       } else {
  //         return [{ name: '' }]
  //       }
  //     } else {
  //       return [{ name: '' }]
  //     }
  //   }
  // },
  mounted () {
  },
  watch: {
    // 监测数值
    'info.company': {
      handler: function (n) {
        if (n.length > 50) {
          this.info['company'] = this.info['company'].slice(0, 50)
        }
      }
    },
    'info.company_remark': {
      handler: function (n) {
        if (n.length > 500) {
          this.info['company_remark'] = this.info['company_remark'].slice(0, 500)
        }
      }
    },
    'info.work_experience': {
      handler: function (n) {
        this.limitNumber(n, 'work_experience', 1000)
      }
    },
    'info.achievements': {
      handler: function (n) {
        this.limitNumber(n, 'achievements', 1000)
      }
    },
    'info.study_experience': {
      handler: function (n) {
        this.limitNumber(n, 'study_experience', 1000)
      }
    },
    'info.support_resource': {
      handler: function (n) {
        this.limitNumber(n, 'support_resource', 1000)
      }
    },
    'info.want_resource': {
      handler: function (n) {
        this.limitNumber(n, 'want_resource', 1000)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../../../../style/bulma/app.sass'

.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */
  opacity: 0

input
  width: 100%
  &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder  /* Mozilla Firefox 19+ */
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder /* Internet Explorer 10-11 */
    color: #bbbec4
    font-size: 12px

.form-all
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  +mobile
    margin: 0
  .win
    width: 100%
    position: relative
    .form
      background-color: #fff
      width: 80%
      .form-main
        .job-title-content
          padding-left: 62px
          span
            display: block
            font-size: 14px
            color: #4a4a4a
            padding-bottom: 8px
            line-height: 1
          .jtc-wrap
            width: 60%
          +mobile
            span
              padding-left: 0
            .jtc-wrap
              width: auto
        .company-scale
          display: flex
          justify-content: space-between
          +mobile
            display: block
          .scale
            flex-grow: 1
          .remark
            flex-grow: 1
            margin-left: 15px
            // margin-top: 44px
            ::v-deep .field.modify
              align-items: center
            ::v-deep .input-wrapper
              padding-top: 3px
              padding-bottom: 3px
              border-color: #dddee1
              input
                height: 16px
            +mobile
              margin-left: 0
              margin-top: 12px
        .submit
          display: flex
          justify-content: center
          margin-top: 40px
          .input
            display: flex
            justify-content: center
            width: 250px
            height: 50px
            border: 2px solid #D7B375
            color: $primary3
            font-size: 16px
            text-align: center
            outline: none
            margin: 0 auto
            cursor: pointer

.textarea-input
  resize: none
  outline: none
  width: 100%
  height: 80px
  border: none
  font-size: 14px
  &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder  /* Mozilla Firefox 19+ */
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder /* Internet Explorer 10-11 */
    color: #bbbec4
    font-size: 12px

.input-extra
  // float: right
  font-size: 14px
  color: #bbbec4

.remark-to-user
  margin: 25px 0
  font-size: 12px
  color: #868686

.subTitle
  margin: -15px 0 12px 14px
  font-size: 14px
  color: #888

// btn 相关
.save-cancel-btns
  display: flex
  justify-content: flex-end
  align-items: baseline
  .cancel-btn
    padding: 6px 76px
    border: 1px solid $primary3
    border-radius: 5px
    color: $primary3
    margin-right: 20px
    cursor: pointer
  .save-btn
    padding: 6px 76px
    border: 1px solid $primary3
    border-radius: 5px
    background-color: $primary3
    color: #fff
    cursor: pointer
</style>
